import { Box, Grid, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import RefundIcon from "../img/refreshicon.png"
import Cancellation from "../img/cancelationtick.png"
import styleCss from "../Style/style"
import Processing from "../img/processing.png"

const RefundTracker = () => {
    return (
        <>
            <Box
                sx={{
                    bgcolor: " #fff",
                    borderRadius: "30px",
                    display: "block",
                    padding: '20px',
                    overflow: 'hidden',
                    "@media (max-width:600px)": {
                        padding: '25px 8px',
                    },
                }}
            >
                <Grid container spacing={2}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Link style={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: 14,
                            fontWeight: 400,
                            textAlign: 'left',
                            color: '#717182',
                            textDecoration: 'unset',
                            marginBottom: '10px',
                        }}><img src={RefundIcon} style={{ verticalAlign: 'middle' }} /> Refund Tracker</Link>
                    </Grid>
                    <Grid size={{ md: 10, xs: 9 }}>
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: 16,
                            fontWeight: 600,
                            textAlign: 'left',
                            color: '#030213',
                        }}>
                            Refund for PNR: RB123456789
                        </Typography>
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: 14,
                            fontWeight: 400,
                            textAlign: 'left',
                            color: '#717182',
                        }}>
                            Amount: ₹1864
                        </Typography>
                    </Grid>
                    <Grid size={{ md: 2, xs: 3 }}>
                        <Typography sx={{
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: 12,
                            fontWeight: 400,
                            textAlign: 'center',
                            color: '#12398c',
                            padding: '3px 6px',
                            borderRadius: '6px',
                            backgroundColor: '#dbeafe',
                        }}>
                            Processing
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Grid sx={{ display: 'flex', marginBottom: '20px' }}>
                            <Grid sx={{ marginRight: '10px' }}>
                                <img src={Cancellation} alt="" style={{ verticalAlign: 'middle' }} />
                            </Grid>
                            <Grid>
                                <Typography sx={styleCss.CancelationStyle}>
                                    Cancellation Requested
                                </Typography>
                                <Typography sx={styleCss.CancelationDate}>
                                    2025-01-20
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid sx={{ display: 'flex', marginBottom: '20px' }}>
                            <Grid sx={{ marginRight: '10px' }}>
                                <img src={Cancellation} alt="" style={{ verticalAlign: 'middle' }} />
                            </Grid>
                            <Grid>
                                <Typography sx={styleCss.CancelationStyle}>
                                    Refund Approved
                                </Typography>
                                <Typography sx={styleCss.CancelationDate}>
                                    2025-01-20
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid size={{ md: 8, xs: 6 }}>
                        <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid>
                                <img src={Processing} alt="" style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                            </Grid>
                            <Grid>
                                <Typography sx={styleCss.ProcessingStyle}>
                                    Processing Payment
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ md: 4, xs: 6 }} sx={{ textAlign: 'end', }}>
                        <Typography sx={styleCss.ProcessingExpected}>
                            Expected: 2-3 days
                        </Typography>
                    </Grid>
                    <Grid size={{ md: 8, xs: 12 }}>
                        <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid>
                                <img src={Processing} alt="" style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                            </Grid>
                            <Grid>
                                <Typography sx={styleCss.ProcessingStyle}>
                                    Amount Credited
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'end', }}>

                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '10px', marginBottom: '10px' }}>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography sx={{
                            fontFamily: 'Segoe UI',
                            fontSize: 13,
                            fontWeight: 300,
                            textAlign: 'left',
                            color: '#305cbc',
                            padding: '10px',
                            borderRadius: '6px',
                            backgroundColor: '#eff6ff',
                            marginTop: '15px',
                        }}>
                            <strong> Note:</strong>  Refunds are processed within 5-7 working days. You will receive an SMS and email confirmation once the amount is credited.
                        </Typography>
                    </Grid>
                </Grid>
            </Box >
        </>
    )
}

export default RefundTracker